function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.25,
  width: 18,
  height: 18,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 19,
  height: 19
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.25,
  width: 18,
  height: 18,
  fill: "url(#pattern1)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.25,
  width: 18,
  height: 18,
  fill: "#676767"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0",
  transform: "scale(0.00980392)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0",
  transform: "scale(0.00980392)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 102,
  height: 101,
  xlinkHref: "data:image/png;base64,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"
}));

var SvgFacebookIcon = function SvgFacebookIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-icon.0a0e94d6.svg";
export { ForwardRef as ReactComponent };